import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { PurchaseOrderEnums } from 'src/app/enum/purchase-order-enum';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { PurchaseOrderDetailModel } from 'src/app/models/shopping/purchase-order-detail.model';
import { PurchaseOrderModel } from 'src/app/models/shopping/purchase-order.model';
import { ArticlesForPurchaseOrderTableModel } from 'src/app/models/tables/shopping/article-for-purchase-order-table.model';
import { ArticlesWithOrderForPurchaseOrderTableModel } from 'src/app/models/tables/shopping/article-with-order-for-purchase-order-table.model';
import { PurchaseDetailRegisterModel } from 'src/app/models/tables/shopping/purchase-order-detail-register-table.model';
import { PurchaseOrderDetailService } from 'src/app/services/shopping/purchase-order-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-purchase-order-detail',
  templateUrl: './purchase-order-detail.component.html',
  styleUrls: ['./purchase-order-detail.component.scss'],
  standalone: false
})
export class PurchaseOrderDetailComponent implements OnInit {

  @Input() purchaseOrderModel: PurchaseOrderModel = new PurchaseOrderModel();
  @Input() quantityDetails: number = 0;
  @Input() disableActions: boolean = false;
  @Input() disableDetail: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() updateHeader = new EventEmitter<true>();

  ascendant: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    }
  ];
  columnSort: string | null = null;
  detailData: PagedResponseModel<PurchaseDetailRegisterModel> = new PagedResponseModel<PurchaseDetailRegisterModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  clearSelectionTrigger: number = 0;
  formPurchaseOrderDetail: FormGroup = new FormGroup({});
  isFormView: boolean = false;
  limit: number = 10;
  newArticlesDetail: number[] = [];
  page: number = 1;
  purchaseOrderDetailModel: PurchaseOrderDetailModel = new PurchaseOrderDetailModel();
  showAccordion: boolean = false;
  swPurchaseOrderInternalOrder: boolean = false;
  tableActions: TableAction[] = [];

  component = CustomTableSelectComponent;
  inputsForArticleForPurchaseOrder$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  })
  inputsForArticleWithOrder$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: []
  })
  outputForArticleForPurchaseOrder$ = new Subject<any>();
  outputForArticleWithOrder$ = new Subject<any>();

  dataArticle: PagedResponseModel<ArticlesForPurchaseOrderTableModel> = new PagedResponseModel<ArticlesForPurchaseOrderTableModel>();
  headerArticle: ColumnResponseModel[] = [];
  ascendantArticle: boolean = true;
  columnSortArticle: string | null = null;
  filtersArticle: ColumnResponseModel[] = [];
  limitArticle: number = 5;
  pageArticle: number = 1;

  dataArticleWithOrder: PagedResponseModel<ArticlesWithOrderForPurchaseOrderTableModel> = new PagedResponseModel<ArticlesWithOrderForPurchaseOrderTableModel>();
  headerArticleWithOrder: ColumnResponseModel[] = [];
  ascendantArticleWithOrder: boolean = true;
  columnSortArticleWithOrder: string | null = null;
  filtersArticleWithOrder: ColumnResponseModel[] = [];
  limitArticleWithOrder: number = 10;
  pageArticleWithOrder: number = 1;

  @ViewChild('articleForPurchaseOrder') articleForPurchaseOrderModalComponent?: CustomModalComponent | null = null;
  @ViewChild('articleWithOrder') articleWithOrderModalComponent?: CustomModalComponent | null = null;

  constructor(private purchaseOrderDetailService: PurchaseOrderDetailService,
    private toastHandlerService: ToastHandlerService,
  ) { }

  async ngOnInit() {
    this.tableActions = [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
    await this.getColumns();

    this.outputForArticleForPurchaseOrder$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload, false);
          break;
        case 'onFilterChange':
          this.onFilterChangeArticle(payload, false);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    this.outputForArticleWithOrder$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload, true);
          break;
        case 'onFilterChange':
          this.onFilterChangeArticle(payload, true);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const purchaseOrderModel = changes["purchaseOrderModel"];
    if (purchaseOrderModel && !purchaseOrderModel.firstChange) {
      this.clearSelectionTrigger++;
      this.getFormView(false);
      this.getPurchaseOrderDetailsForCaptureTable();
      this.disabledButton = this.purchaseOrderModel.purchaseOrderId === 0 || this.purchaseOrderModel.purchaseOrderState !== PurchaseOrderEnums.stateOpen;
    }

    const disabledActions = changes["disabledActions"];
    if (disabledActions && !disabledActions.firstChange) {
      this.tableActions = this.disableActions ? [] : [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    }
  }

  async deleteSomeDetails(ids: number[]) {
    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle de la orden de compra?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.purchaseOrderDetailService.deleteSomeDetails(ids));
        this.toastHandlerService.showToast(
          'success',
          'El detalle de la orden de compra fue eliminado exitosamente.'
        );
        this.getUpdateListDetailByDelete();
      } catch (error) {
        console.error('Error al eliminar el detalle del orden de compra.', error);
      }
    }
  }

  async getArticlesForSelection(withOrder: boolean) {
    try {
      if (!withOrder) {
        this.dataArticle = await firstValueFrom(
          this.purchaseOrderDetailService.getArticlesForSelection(this.pageArticle, this.limitArticle,
            this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      } else {
        this.dataArticleWithOrder = await firstValueFrom(
          this.purchaseOrderDetailService.getArticlesWithOrderForSelection(this.purchaseOrderModel.branchId,
            this.pageArticleWithOrder, this.limitArticleWithOrder, this.columnSortArticleWithOrder, this.ascendantArticleWithOrder,
            this.filtersArticleWithOrder));
      }
      this.updateInputs(withOrder);
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.purchaseOrderDetailService.getColumnsForCaptureTable());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsArticle(withOrder: boolean) {
    try {
      if (!withOrder) {
        if (this.headerArticle.length === 0) {
          this.headerArticle = await firstValueFrom(this.purchaseOrderDetailService.getColumnsForArticleSelection());
        }
      } else {
        if (this.headerArticleWithOrder.length === 0) {
          this.headerArticleWithOrder = await firstValueFrom(this.purchaseOrderDetailService.getColumnsForArticleWithOrderSelection());
        }
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getPurchaseOrderDetailsForCaptureTable() {
    try {
      this.detailData = await firstValueFrom(this.purchaseOrderDetailService.getPurchaseOrderDetailsForCaptureTable(this.page, this.limit, this.columnSort, this.ascendant,
        this.purchaseOrderModel.purchaseOrderId));
      const quantityDetails = this.detailData.totalItems;
      this.emitQuantityDetails.emit(quantityDetails);
    } catch (error) {
      console.error('Error al buscar los detalles de la orden de compra.', error);
    }
  }

  async getSelectedItems(selectedItems: any) {
    try {
      const articleIds = selectedItems.map((item: any) => parseInt(item.id));
      await firstValueFrom(this.purchaseOrderDetailService.createPurchaseOrderDetails(articleIds, this.purchaseOrderModel.purchaseOrderId));
      this.toastHandlerService.showToast('success', 'El detalle de la orden de compra fue creado exitosamente.');
      this.getPurchaseOrderDetailsForCaptureTable();
    } catch (error) {
      console.error('Error al crear el detalle de la orden de compra.', error);
    }
  }

  async getSelectedItemsWithOrder(selectedItems: any) {
    try {
      await firstValueFrom(this.purchaseOrderDetailService.createPurchaseOrderDetailsWithOrder(selectedItems, this.purchaseOrderModel.purchaseOrderId));
      this.toastHandlerService.showToast(
        'success',
        'El detalle de la orden de compra fue creado exitosamente.'
      );
      this.getPurchaseOrderDetailsForCaptureTable();
    } catch (error) {
      console.error('Error al crear el detalle de la orden de compra.', error);
    }
  }

  getUpdateListDetailByDelete() {
    this.purchaseOrderDetailModel = new PurchaseOrderDetailModel();
    this.clearSelectionTrigger++;
    this.getPurchaseOrderDetailsForCaptureTable();
    this.updateHeader.emit(true);
  }

  async onAction(event: { action: string, item?: PurchaseDetailRegisterModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.purchaseOrderDetailService.getPurchaseOrderDetailById(event.item!.id));
      if (response)
        this.purchaseOrderDetailModel = response;
      this.getFormView(true);
    }

    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteSomeDetails(event.selectedItems);
    }
  }

  async onFilterChangeArticle(event: { filters: any }, withorder: boolean) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    if (!withorder) {
      this.filtersArticle = this.removeDuplicates(filters);
      this.filtersArticle.forEach((filter: any) => this.processFilter(filter, false));
    } else {
      this.filtersArticleWithOrder = this.removeDuplicates(filters);
      this.filtersArticleWithOrder.forEach((filter: any) => this.processFilter(filter, true));
    }
    this.updateInputs(withorder);
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getPurchaseOrderDetailsForCaptureTable();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number },
    withOrder: boolean) {
    if (!withOrder) {
      this.pageArticle = event.page;
      this.limitArticle = event.pageSize;
      this.columnSortArticle = event.sortField || null;
      this.ascendantArticle = event.sortOrder === 1;
    } else {
      this.pageArticleWithOrder = event.page;
      this.limitArticleWithOrder = event.pageSize;
      this.columnSortArticleWithOrder = event.sortField || null;
      this.ascendantArticleWithOrder = event.sortOrder === 1;
    }
    this.getArticlesForSelection(withOrder);
  }

  async openModal(withOrder: boolean) {
    if (!withOrder) { this.filtersArticle = []; } else { this.filtersArticleWithOrder = []; }
    await Promise.all([
      this.getColumnsArticle(withOrder),
      this.getArticlesForSelection(withOrder)]
    );
    this.updateInputs(withOrder);
    if (!withOrder) {
      this.articleForPurchaseOrderModalComponent && this.articleForPurchaseOrderModalComponent.show();
    } else {
      this.articleWithOrderModalComponent && this.articleWithOrderModalComponent.show();
    }
  }

  processFilter(filter: any, withOrder: boolean): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      if (!withOrder)
        this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
      else
        this.filtersArticleWithOrder = this.filtersArticleWithOrder.filter(f => f.propertyName !== propertyName);
    } else {
      let existingFilter;
      if (!withOrder)
        existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      else
        existingFilter = this.filtersArticleWithOrder.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs(withOrder: boolean) {
    if (!withOrder) {
      this.inputsForArticleForPurchaseOrder$.next({
        headers: this.headerArticle,
        data: this.dataArticle,
        showCheckbox: true,
        showRecover: true,
        isMultipleSelect: true,
        limitPaginator: true,
        filters: this.filtersArticle,
        actions: [
          {
            label: 'Imágenes',
            icon: 'pi pi-image',
            action: 'view-image'
          }
        ]
      });
    } else {
      this.inputsForArticleWithOrder$.next({
        headers: this.headerArticleWithOrder,
        data: this.dataArticleWithOrder,
        showCheckbox: true,
        showRecover: true,
        isMultipleSelect: true,
        filters: this.filtersArticleWithOrder
      });
    }
  }
}
